import React from 'react';
import Tabs from '@ssg/common/Components/Tabs';
import Box from '../../../Components/Layout/Box';
import EconomyTabNew from './EconomyTabNew';
import EconomyTab from './EconomyTab';
import JobsTable from './JobsTable';
import ReportsTab from './ReportsTab';
import MachinesTable from './MachinesTable';
import arraysHasMatchingValue from '@ssg/common/Helpers/arraysHasMatchingValue';
import UserContext from '../../../UserContext';
import SubProjects from './SubProjects';
import CaseMailsTab from './CaseMailsTab';
import RequisitionsTab from './RequisitionsTab';
import { GetSingleCase_case, Permissions } from '../../../GraphQL';
import { FeatureFlagEnums } from '@ssg/common/FeatureFlagEnums';
import { useFlag } from '@unleash/proxy-client-react';

interface Props {
	caseData: GetSingleCase_case;
}

const MiscBox: React.FC<Props> = ({ caseData }): React.ReactElement => {
	const userContext = React.useContext(UserContext);
	const userPermissions = userContext.user?.permissions ?? [];
	const showEconomy = arraysHasMatchingValue(userPermissions, [Permissions.CASES_ECONOMY_VIEW]);
	const caseViewExternal = arraysHasMatchingValue(userPermissions, [Permissions.CASES_VIEW_EXTERNAL]);
	const economyLayout2 = useFlag(FeatureFlagEnums.ECONOMY_LAYOUT_2);

	const tabs: string[] = React.useMemo(() => {
		const baseTabs = ['common.economy', 'case.caseMails', 'common.reports', 'common.machines', 'requisitions.overviewTitle', 'jobs.overviewTitle', 'case.subProjects'];
		return economyLayout2 ? ['common.economy2', ...baseTabs] : baseTabs;
	}, [economyLayout2]);

	const filteredTabs = React.useMemo(() => tabs.filter(t => !(t.endsWith('economy') || t.endsWith('economy2')) || (showEconomy && !caseViewExternal)), [caseViewExternal, showEconomy, tabs]);

	const [activeTab, setActiveTab] = React.useState<string>(filteredTabs[0]);

	return (
		<Box title="common.miscellaneous" className="text-blue mb-8" full>
			<Tabs titles={filteredTabs} active={activeTab} onClick={setActiveTab} full>
				<div style={{ height: economyLayout2 ? '580px' : '390px' }}>
					{activeTab === 'common.economy2' && <EconomyTabNew caseErpId={caseData.erpId} caseErpNo={caseData.erpNo} caseId={caseData.id} fixedPriceOnCase={caseData.fixedPriceOnCase} />}
					{activeTab === 'common.economy' && <EconomyTab caseErpId={caseData.erpId} caseErpNo={caseData.erpNo} caseId={caseData.id} fixedPriceOnCase={caseData.fixedPriceOnCase} />}
					{activeTab === 'case.caseMails' && <CaseMailsTab id={caseData.erpNo} />}
					{activeTab === 'common.reports' && <ReportsTab caseData={caseData} />}
					{activeTab === 'common.machines' && <MachinesTable caseData={caseData} caseViewExternal={caseViewExternal} />}
					{activeTab === 'requisitions.overviewTitle' && <RequisitionsTab caseData={caseData} />}
					{activeTab === 'jobs.overviewTitle' && <JobsTable caseData={caseData} />}
					{activeTab === 'case.subProjects' && <SubProjects caseData={caseData} />}
				</div>
			</Tabs>
		</Box>
	);
};

export default MiscBox;
